import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { variancePctFromRatio, varianceClassFromRatio } from '../formatters/detail-formatters'

@Component({
    selector: 'app-variance-pill',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-container *ngIf="pct() as p; else dash">
            <span [class]="cls()" data-testid="variance-pct">
                <strong>{{ p > 0 ? '+' : '' }}{{ p }}%</strong>
                <i *ngIf="(ratio || 0) > 1.1"
                   class="fa fa-exclamation-triangle warn-icon"
                   title="Touch exceeds standard"></i>
            </span>
        </ng-container>
        <ng-template #dash>
            <span class="variance-unknown">—</span>
        </ng-template>
    `,
    styles: [`
        :host { display: inline-flex; align-items: center; gap: .25rem; font-variant-numeric: tabular-nums; }
        .variance-over   { color: #b42318; }
        .variance-under  { color: #6941c6; }
        .variance-ok     { color: #027a48; }
        .variance-unknown { color: #98a2b3; }
        .warn-icon { font-size: .75em; }
    `]
})
export class VariancePillComponent {
    @Input() ratio: number | null = null

    pct(): number | null {
        return variancePctFromRatio(this.ratio)
    }

    cls(): string {
        return varianceClassFromRatio(this.ratio)
    }
}
